import axios from 'axios';
import { API_URL } from '../utils/ApiLinks';

export const getExchangeRate = async (tipoCambio: 'compra' | 'venta') => {
  try {
    const response = await axios.post(
      `${API_URL}/ExchangeRate/GetExchangeRate`,
      tipoCambio ,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    return undefined;
  }
};

const handleAuthError = (error: any) => {
  if (error.response) {
    throw new Error(error.response.data || error.message);
  } else {
    throw new Error(error.message || 'An unknown error occurred');
  }
};
